import { Controller } from "@hotwired/stimulus";

// The subscribe flyover in the status page header. This is a form rather than a
// menu of links, so it doesn't use the shared dropdown controller: opening it
// should put the cursor in the email field, and Escape should close it and hand
// focus back to the toggle.
export default class extends Controller {
  static targets = ["button", "panel", "email"];

  toggle(event) {
    event.preventDefault();
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.panelTarget.classList.remove("hidden");
    this.buttonTarget.setAttribute("aria-expanded", "true");
    if (this.hasEmailTarget) this.emailTarget.focus();
  }

  close() {
    this.panelTarget.classList.add("hidden");
    this.buttonTarget.setAttribute("aria-expanded", "false");
  }

  closeOnOutsideClick(event) {
    if (this.isOpen && !this.element.contains(event.target)) this.close();
  }

  closeOnEscape(event) {
    if (event.key !== "Escape" || !this.isOpen) return;
    this.close();
    this.buttonTarget.focus();
  }

  get isOpen() {
    return !this.panelTarget.classList.contains("hidden");
  }
}
